<section class="mainSection">
    <div class="save-section">
        <div class="main-bar">
            <h2 class="text maintitle" [innerHTML]="saveSection?.panelText"></h2>
            <app-citi-shop-add-to-browser-button
                *ngIf="csp.eanbleDownloadButton()"
                [sectionName]="saveSection?.panelText"
                [buttonColor]="'white'"
                (buttonClicked)="buttonClicked($event)">
            </app-citi-shop-add-to-browser-button>
            <p *ngIf="!csp.eanbleDownloadButton()" class="text displayMsg" [innerHTML]="saveSection?.mobileText"></p>
        </div>
    </div>

    <div class="cardartSection">
        <div class="backgroundImage" role="presentation" alt=""  [cache]="csp.imagePrefix() + saveSection?.backgroundImagePath" 
        [lazyload]="csp.imagePrefix() + saveSection?.backgroundImagePath">
            <div class="section">
                <div class="leftSection">
                    <img  class="mobileImg"  [cache]="csp.imagePrefix() + saveSection?.cardArtImagePath" 
                    [lazyload]="csp.imagePrefix() + saveSection?.cardArtImagePath"
                        role="presentation" alt="">
                </div>
                <div class="rightSection">
                    <h4 [innerHTML]="saveSection?.cardartHeading"></h4>
                    <p [innerHTML]="saveSection?.cardartSubHeading"></p>
                    <p>
                        <a target="_blank" rel="noopener" [mktRouterLink]="saveSection.link" class="linkText"
                        (click)="onSaveSectionLinkClick(saveSection.linkText, saveSection?.cardartHeading)" [innerHTML]="saveSection.linkText" attr.aria-label="{{saveSection.linkText}}">
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
